import React, { useState } from "react";

import { Grid, Button, TextField } from "@mui/material";
import { BlockStandard } from "components/admin/BlockStandard";
import { EditOutlined } from "@mui/icons-material";
import { PhotoUploadGrid } from "./PhotoUploadGrid";

export const BlockDetail = ({
  blockData,
  blockPos,
  onChange,
}: BlockDetailProps) => {
  const [numPavements, setNumPavements] = useState<string>("");
  // @ts-expect-error isNan typecheck is messed up for some reason
  const isNumPavementsValid = !numPavements || !isNaN(numPavements);
  const displayAdornment =
    isNumPavementsValid && !(+numPavements === blockData.pavementList.length);

  const handleNameUpdate = ({ target: { value } }) => {
    const updatedBlock = { ...blockData, name: value };
    onChange(updatedBlock);
  };

  const handleNumPavUpdate = () => {
    if (isNumPavementsValid) {
      const newPavList: string[] = [];
      for (let i = 0; i < +numPavements; i++) {
        newPavList.push("");
      }
      const updatedBlock = { ...blockData, pavementList: newPavList };
      onChange(updatedBlock);
    }
  };

  const handleObsUpdate = ({ target: { value } }) => {
    const updatedBlock = { ...blockData, obs: value };
    onChange(updatedBlock);
  };

  const handlePavNameUpdate = ({ value }, pos) => {
    const updatedList = [...blockData.pavementList];
    updatedList.splice(pos, 1, value);
    const updatedBlock = { ...blockData, pavementList: updatedList };
    onChange(updatedBlock);
  };

  const handlePhotosChange = (photos: File[]) => {
    const updatedBlock = { ...blockData, pictures: photos };
    onChange(updatedBlock);
  };

  return (
    <BlockStandard title={`Detalhar bloco (${blockPos + 1})`}>
      <Grid item container gap={2}>
        <TextField
          label="Nome do bloco"
          sx={{ flex: 1 }}
          value={blockData.name}
          onChange={handleNameUpdate}
        />
        <TextField
          label="Nº pavimentos"
          sx={{ flex: 1 }}
          value={numPavements}
          error={!isNumPavementsValid}
          onChange={({ target }) => setNumPavements(target.value)}
          InputProps={
            displayAdornment
              ? {
                  endAdornment: (
                    <Button variant="contained" onClick={handleNumPavUpdate}>
                      <EditOutlined />
                    </Button>
                  ),
                }
              : {}
          }
        />
      </Grid>
      <Grid
        item
        container
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        {blockData.pavementList.map((pavementName, pos) => (
          <TextField
            label={`Pavimento (${pos + 1})`}
            value={pavementName}
            onChange={({ target }) => {
              handlePavNameUpdate(target, pos);
            }}
          />
        ))}
      </Grid>
      <TextField
        multiline
        minRows={3}
        label="Observações"
        onChange={handleObsUpdate}
      />

      <PhotoUploadGrid
        photos={blockData.pictures}
        onPhotosChange={handlePhotosChange}
        buttonText="Enviar foto"
      />
    </BlockStandard>
  );
};

export type BlockDetailProps = {
  blockData: BlockDetailItem;
  blockPos: number;
  onChange: (block: BlockDetailItem) => void;
};

export type BlockDetailItem = {
  name: string;
  pavementList: String[];
  obs: string;
  pictures: File[];
};

export const emptyBlock: BlockDetailItem = {
  name: "",
  pavementList: [],
  obs: "",
  pictures: [],
};
